import { Link } from '@tanstack/react-router';
import { formatPublishedAt } from '../../../lib/format-date';
import { FALLBACK_IMG, mediaSrc, SmartImage, type MediaRef } from '../../../components/media/SmartImage';
import { CategoryLink } from '../../../components/CategoryLink';

export type ArticleCardData = {
  id: string;
  title: string;
  slug: string;
  excerpt: string | null;
  contentText: string | null;
  publishedAt: string | null;
  category: { id: string; name: string; slug: string } | null;
  coverMedia: MediaRef;
};

export { FALLBACK_IMG };

/** Plain URL for the cover image. Prefer `<SmartImage>` when rendering. */
export function imageFor(card: { coverMedia: MediaRef }) {
  return mediaSrc(card.coverMedia);
}

export function ArticleCard({ card }: { card: ArticleCardData }) {
  return (
    <div className="trending-news-item mb-30">
      <div className="trending-news-thumb">
        <SmartImage media={card.coverMedia} alt={card.title} />
        {/* Decorative badge. It used to be `<a href="#">`, i.e. a nameless
            dead link repeated once per card — 15+ per listing page. */}
        <div className="icon" aria-hidden="true">
          <span><i className="fas fa-bolt" /></span>
        </div>
      </div>
      <div className="trending-news-content">
        <div className="post-meta">
          {card.category && (
            <div className="meta-categories">
              <CategoryLink slug={card.category.slug} name={card.category.name} />
            </div>
          )}
          <div className="meta-date"><span>{formatPublishedAt(card.publishedAt)}</span></div>
        </div>
        <h3 className="title">
          <Link to="/articles/$slug" params={{ slug: card.slug }}>{card.title}</Link>
        </h3>
        <p className="text">{(card.excerpt ?? card.contentText ?? '').slice(0, 100)}</p>
      </div>
    </div>
  );
}
